import { UserProvider } from 'Providers/UserProvider';
import { useGlobalState } from 'Providers/GlobalStateProvider';
import React from 'react';

import { toast } from 'react-toastify';
import { SelectedOrganizationProvider } from 'Providers/OrganizationProvider';

const PrivateRoutes = ({ children }: { children: React.ReactNode }) => {
  const [{ userToken }] = useGlobalState();

  if (window.location.pathname.includes('events/') && !userToken) {
    const indexOfS = window.location.pathname.indexOf('s') + 2;
    const eventId = window.location.pathname.substring(indexOfS);
    localStorage.setItem('deep-link-event-id', eventId);
    toast.error('Please login to see requested lift event');
  }

  return (
    <UserProvider>
      <SelectedOrganizationProvider>{children}</SelectedOrganizationProvider>
    </UserProvider>
  );
};

export default PrivateRoutes;
